import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { instance } from "../../../../../../Actions/AxiosInstance";
import CheckImg from "../../../../../../Assets/Images/aaa.png";

class details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      noticeDays: 0,
      employeenotice: false,
      isselfassign: false,
      ismanagerassign: false,
      managernotice: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.updatePostData = this.updatePostData.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
      nextButtonLabel: "Save",
    });
  }

  onSubmit() {
    const {
      exitpolicyid,
      policyname,
      description,
      noticeperioddays,
      isselfresignallowed,
      ismanagerresignallowed,
      isselfnoticechangeallowed,
      ismanagernoticechangeallowed,
    } = this.props.postData;

    const data = {
      exitpolicyid,
      policyname,
      description,
      noticeperioddays,
      isselfresignallowed,
      ismanagerresignallowed,
      isselfnoticechangeallowed,
      ismanagernoticechangeallowed,
    };
    // const TEMP = {"exitpolicyid":null,"policyname":"poinuio","description":null,"noticeperioddays":"32","isselfresignallowed":false,"ismanagerresignallowed":false,"isselfnoticechangeallowed":false,"ismanagernoticechangeallowed":false,"subscriptionid":65}
    if (noticeperioddays == 0) {
      this.props.enqueueSnackbar("Notice period cannot be zero", {
        variant: "error",
      });
    } else if (!noticeperioddays) {
      this.props.enqueueSnackbar(
        get({}, "details[0].context.label", "please enter notice period days"),
        { variant: "error" },
      );
    } else if (!isselfresignallowed && !ismanagerresignallowed) {
      this.props.enqueueSnackbar("Please allow at least one resign method", {
        variant: "error",
      });
    } else {
      instance
        .post("exit/exitpolicy", data)
        .then(() => {
          this.props.enqueueSnackbar("saved successfully", {
            variant: "success",
          });
          this.props.getExitPolicies();
          this.props.history.push("/config/hris/employee/exit_policy");
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  updatePostData(key, value) {
    const { postData } = this.props;
    postData[key] = value;
    this.props.updatePostData(postData);
  }

  render() {
    const {
      noticeperioddays,
      isselfresignallowed,
      ismanagerresignallowed,
      isselfnoticechangeallowed,
      ismanagernoticechangeallowed,
    } = this.props.postData;
    return (
      <div>
        <Grid>
          <p className="input-form-label">
            <FormattedMessage id="#" defaultMessage="Notice Period " />
          </p>
          <p className="input-form-label">
            <FormattedMessage id="#" defaultMessage=" Number of days" />
          </p>
          <TextField
            id="outlined-dense"
            margin="dense"
            variant="outlined"
            type="number"
            InputProps={{
              inputProps: {
                min: "1",
              },
            }}
            value={noticeperioddays}
            onChange={(e) =>
              this.updatePostData(
                "noticeperioddays",
                Math.round(e.target.value) ? Math.round(e.target.value) : 1,
              )
            }
          />
        </Grid>
        <Grid style={{ marginTop: 12 }}>
          <p className="depedent-select-list-head">
            <FormattedMessage
              id="#"
              defaultMessage="Can the employee self-resign ?"
            />
          </p>
          <div
            className="depedent-select-list"
            onClick={() => this.updatePostData("isselfresignallowed", true)}
            aria-expanded={isselfresignallowed}
          >
            <span>
              <FormattedMessage id="LbYes" defaultMessage="Yes" />
            </span>
            {isselfresignallowed ? (
              <span className="floatright">
                <img src={CheckImg} height="20" />
              </span>
            ) : (
              <span className="not-selected" />
            )}
          </div>
          <div className="et-level3">
            <Collapse
              in={isselfresignallowed}
              timeout={2}
              unmountOnExit
              className="padding20 overflow-initial"
            >
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="#"
                  defaultMessage="Can the employee request for  a change  in the notice period ?"
                />
              </p>
              <div
                className="depedent-select-list"
                aria-expanded={isselfnoticechangeallowed}
                onClick={() =>
                  this.updatePostData("isselfnoticechangeallowed", true)
                }
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {isselfnoticechangeallowed ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
              <div
                className="depedent-select-list"
                aria-expanded={!isselfnoticechangeallowed}
                onClick={() =>
                  this.updatePostData("isselfnoticechangeallowed", false)
                }
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {!isselfnoticechangeallowed ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
            </Collapse>
          </div>
          <div
            className="depedent-select-list"
            aria-expanded={!isselfresignallowed}
            onClick={() => this.updatePostData("isselfresignallowed", false)}
          >
            <span>
              <FormattedMessage id="LbNo" defaultMessage="No" />
            </span>
            {!isselfresignallowed ? (
              <span className="floatright">
                <img src={CheckImg} height="20" />
              </span>
            ) : (
              <span className="not-selected" />
            )}
          </div>
          <div style={{ marginTop: 40 }}>
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="#"
                defaultMessage="Can the manager of this employee initiate separation?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() =>
                this.updatePostData("ismanagerresignallowed", true)
              }
              // onClick={this.handleChange.bind(this, "ismanagerassign")}
              aria-expanded={ismanagerresignallowed}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {ismanagerresignallowed ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
            <div className="et-level3">
              <Collapse
                in={ismanagerresignallowed}
                timeout={2}
                unmountOnExit
                className="padding20 overflow-initial"
              >
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="#"
                    defaultMessage="Can the manager request for change  in the notice period ?"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() =>
                    this.updatePostData("ismanagernoticechangeallowed", true)
                  }
                  aria-expanded={ismanagernoticechangeallowed}
                  // onClick={this.handleChange.bind(this, "managernotice")} ismanagernoticechangeallowed
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {ismanagernoticechangeallowed ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected" />
                  )}
                </div>
                <div
                  className="depedent-select-list"
                  aria-expanded={!ismanagernoticechangeallowed}
                  onClick={() =>
                    this.updatePostData("ismanagernoticechangeallowed", false)
                  }
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {!ismanagernoticechangeallowed ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected" />
                  )}
                </div>
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() =>
                this.updatePostData("ismanagerresignallowed", false)
              }
              // onClick={this.handleCancel.bind(this, "ismanagerassign")}
              aria-expanded={!ismanagerresignallowed}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {!ismanagerresignallowed ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
        </Grid>
      </div>
    );
  }
}
export default withSnackbar(details);
